import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const styles = {
  modalBody: (autoHeight?: boolean) => css`
    min-height: ${autoHeight ? 'auto' : '60vh'};
    min-width: min(${breakpoints.small.max}px, calc(100vw - 50vw));
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `,
  filters: {
    filterContainer: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(2)};
      justify-content: space-between;
      > div {
        width: 100%;
      }
    `,
    camouflage: css`
      visibility: hidden;
    `,
    searchField: css`
      width: 100%;
    `,
  },
  validateUser: {
    footer: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
    `,
    footerActions: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(1)};
    `,
    footerSelectedCount: css`
      color: ${theme.colorsV2.black(60)};
    `,
    button: css`
      text-transform: none;
    `,
  },
  sendSms: {
    container: css`
      border: 1px solid ${theme.colors.neutral20};
      border-radius: ${theme.borderRadius.medium};
      margin-top: ${theme.spacing(1)};
      height: 90%;
      display: flex;
      flex-direction: column;
    `,
    containerHeaderWrapoper: css`
      border-bottom: 1px solid ${theme.colors.neutral20};
      padding: ${theme.spacing(2)};
      display: flex;
    `,
    containerHeaderLeft: css`
      width: 40%;
    `,
    containerHeaderRight: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(1)};
      background-color: ${theme.colors.neutral5};
      border-radius: ${theme.borderRadius.medium};
      padding: ${theme.spacing(1)};
      flex: 1;
    `,
    templateEditor: css`
      border: 0px;
      flex: 1;
      border-bottom: 1px solid ${theme.colors.neutral20};
      border-radius: 0px;
    `,
    tagListContainer: css`
      padding: ${theme.spacing(1, 2)};
      overflow-y: auto;
    `,
  },
};
